import styled from 'styled-components'

const CheckboxDiv = styled.label`
  cursor: pointer;
  color: #848e9c;
  font-size: 14px;

  input {
    cursor: pointer;
    appearance: none;
    outline: 0;
    height: 14px;
    width: 14px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid #848e9c;
    vertical-align: -1.5px;
    margin-right: 5px;

    :hover {
      border-color: #f0b90b;
    }

    :checked {
      background: #f0b90b;
      border-color: #f0b90b;
    }

    :checked:after {
      display: block;
    }

    :after {
      content: '';
      position: relative;
      left: 40%;
      top: 20%;
      width: 15%;
      height: 40%;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      display: none;
    }
  }
`

export default function Checkbox ({
  onChange, text, checked = false, style = {}
}) {
  return (
    <CheckboxDiv style={style}>
      <input type="checkbox" checked={checked} onChange={onChange} />
      {text}
    </CheckboxDiv>
  )
}
